import * as MutationsType from "./mutationsType";
import requestAxios from "@/helpers/request_axios";

export default {
  async getAllOrigins({ commit }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/origins",
        method: "GET",
      });
      let origins = response.data.data;
      commit(MutationsType.SET_ORIGINS, origins);
    } catch (error) {
      throw error.response.data;
    }
  },
  async getOriginById({ commit, state }, { id }) {
    try {
      let origin = state.origins?.find((o) => o.id === id);
      if (!origin) {
        let response = await requestAxios({
          url: `/awy/api/v1/origins/${id}`,
          method: "GET",
        });
        origin = response.data.data;
      }

      commit(MutationsType.SET_ORIGIN_SELECTED, origin);
      commit(MutationsType.SET_ORIGIN, origin);
    } catch (error) {
      throw error.response.data;
    }
  },
  async saveOrigin({ commit }, { data }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/origins",
        method: "POST",
        data: data,
      });
      commit(MutationsType.ADD_ORIGIN, response.data.data);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async updateOrigin({ commit, state }, { id, data }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/origins/${id}`,
        method: "PATCH",
        data: data,
      });
      let origin = response.data.data;
      commit(MutationsType.UPDATE_ORIGIN, origin);
      if (origin.id === state.origin.id) commit(MutationsType.SET_ORIGIN, origin);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async handleOrigin({ commit }, { id, data }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/origins/${id}`,
        method: "PATCH",
        data: data,
      });
      let origin = response.data;
      commit(MutationsType.UPDATE_ORIGIN, origin.data);
      return data;
    } catch (error) {
      throw error.response.data;
    }
  },
  resetOriginSelected({ commit }) {
    commit(MutationsType.SET_ORIGIN_SELECTED, null);
  },
  resetModuleOrigin({ commit }) {
    commit(MutationsType.RESET_ORIGINS, null);
  },
};
